<template>
	<div class="box clearF">
		<div
			class="about-left"
			:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
			:style="{
				'border-left': `1px solid ${dayNightMode == 'day' ? '#000' : '#fff'}`,
			}"
		>
			<h1 class="sora-h1" :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">SERVICES</h1>
			<ul class="about-left-ul">
				<li v-for="(item, index) in aboutData" :key="item.id">
					<div class="about-left-li clearF" @click="openHeight($event)"
						><div>{{ (index * 1 + 1).length >= 2 ? index + 1 : '0' + (index + 1) }}.</div
						><div>{{ item.title_cn }}</div
						><div>{{ item.title_en }}</div></div
					>
					<div class="about-left-content" v-if="item.detailArr">
						<p
							class="about-content-p2"
							:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
							>{{ item.detailArr.con_title_cn }}</p
						>
						<p class="about-content-p3" :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
							>{{ item.detailArr.con_title_en }}{{ item.detailArr.con_title_en }}</p
						>
						<p
							class="about-content-p3 c-about-content-p3"
							:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
							v-html="item.detailArr.content"
						></p>
						<div class="about-left-cont-nav clearF">
							<div class="about-cont-nav-l">
								<p
									v-for="(item, index2) in item.detailArr.services_cn"
									:key="'services_cn' + index2"
									:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
									>{{ item }}</p
								>
								<div class="services-en">
									<p
										v-for="(item, index2) in item.detailArr.services_en"
										:key="'services_en' + index2"
										:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
										>{{ item }}</p
									>
								</div>
							</div>
							<div class="about-cont-nav-r">
								<img :src="item.detailArr.img" alt="" />
							</div>
						</div>
					</div>
				</li>
				<!-- <li>
            <div class="about-left-li"><span>02.</span><span>视觉设计</span>VISUAL DESIGN</div>
            <div class="about-left-content"></div>
          </li>
          <li>
            <div class="about-left-li"><span>06.</span><span>媒体更新</span>CITY RENOVATION</div>
            <div class="about-left-content"></div>
          </li> -->
			</ul>
		</div>

		<div
			class="about-right"
			:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
			:style="{
				'border-left': `1px solid ${dayNightMode == 'day' ? '#000' : '#fff'}`,
			}"
		>
			<div class="about-right-video">
				<img :src="aboutRight.about" alt="" v-if="aboutRight.type == 1" />
				<!-- <img src="../assets/about-play.png" alt=""> -->
				<video :src="aboutRight.about" v-if="aboutRight.type == 2" controls="controls"></video>
			</div>
			<div class="about-right-text c-padding-lr">
				<h1 class="sora-h1" :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">ABOUT</h1>
				<p
					v-html="aboutRight.about_cn"
					:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
				></p>
				<p
					v-html="aboutRight.about_en"
					:class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'"
				></p>
			</div>
			<div class="about-right-clients c-padding-lr">
				<h1 class="sora-h1" :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">CLIENT</h1>
				<div :style="{ background: dayNightMode == 'night' ? '#fff' : '' }"
					><img :src="aboutRight.clients" alt=""
				/></div>
			</div>
			<div class="about-right-awards c-padding-lr">
				<h1 class="sora-h1" :class="dayNightMode == 'day' ? 'day-mode' : 'night-mode'">AWARDS</h1>
				<ul class="awards-ul">
					<li class="awards-li" v-for="item in aboutRightList" :key="item.id">
						<span>{{ item.title }}</span>
						<span>{{ item.time }}</span>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				aboutData: '', //列表数据
				aboutDetail: '', //列表详情
				aboutRight: '', //about右边数据
				aboutRightList: '', //about右边数据列表

				dayNightMode: this.$store.state.dayNightMode,
			};
		},
		created() {
			this.requestList();
			this.aboutFun();
			this.aboutFunList();
		},
		watch: {
			'$store.state.dayNightMode': function() {
				this.dayNightMode = this.$store.state.dayNightMode;
			},
		},
		mounted() {},
		methods: {
			// 关于我们，右边数据,列表
			aboutFunList() {
				this.$post('api/about/awardsInfo').then((res) => {
					let arr = res.data;
					arr.map((item, index) => {
						let time = new Date(parseInt(arr[index].time * 1000));
						console.log(time, 'time');
						arr[index].time = time.getFullYear();
					});
					this.aboutRightList = arr;
				});
			},

			// 关于我们，右边数据
			aboutFun() {
				this.$post('api/about/aboutInfo').then((res) => {
					this.aboutRight = res.data;
				});
			},

			// 请求列表数据
			requestList() {
				this.$post('api/about/servicesList').then((res) => {
					this.aboutData = res.data;

					// 循环的原因，接口就是这么写的
					this.aboutData.map((item, index) => {
						this.requestListDetail(item.id, index);
					});
				});
			},

			// 请求列表详情数据
			requestListDetail(id, index) {
				this.$post('api/about/servicesInfo', { id }).then((res) => {
					// this.aboutDetail = res.data;
					this.aboutData[index].detailArr = res.data;
					this.aboutData[index].title_cn = this.aboutData[index].title_cn + ' ';
					console.log(this.aboutData[index].detailArr);
				});
			},

			openHeight(e) {
				console.log(this.aboutData, 'this.aboutData');
				let dom = e.currentTarget; //事件源
				let domTitle = dom.clientHeight; //标题高度
				let domContent = dom.nextElementSibling.clientHeight; //获取富文本高度
				let domFather = dom.parentNode; //获取父元素

				console.log(domTitle, domContent, domFather); //查看

				// return false
				if (!domFather.id) {
					domFather.style.cssText = `height: ${domTitle + domContent}px`;
					domFather.id = 'in';
					// hover-h1
					let classname = domFather.querySelector('.about-left-li').className;
					domFather.querySelector('.about-left-li').className = `${classname} hover-h1`;
				} else {
					domFather.style.cssText = `height: ${domTitle}px`;
					domFather.id = '';
					domFather.querySelector('.about-left-li').className = `about-left-li`;
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	@font-face {
		font-family: nexalight;
		src: url(../../public/font/NexaLight.otf);
	}
	@font-face {
		font-family: nexabold;
		src: url(../../public/font/NexaBold.otf);
	}
	@font-face {
		font-family: SourceHanSansBold;
		src: url(../../public/font/SourceHanSansCN-Bold.otf);
	}
	@font-face {
		font-family: SourceHanSansNormal;
		src: url(../../public/font/SourceHanSansCN-Normal.otf);
	}
	@font-face {
		font-family: SourceHanSansMedium;
		src: url(../../public/font/SourceHanSansCN-Medium.otf);
	}

	.box {
		background: #dbdcdc;
		display: flex;
	}
	.about-left {
		width: 50%;
		padding: 38px 30px 0 30px;
		border-left: 1px solid #000;
		h1 {
			padding-bottom: 22px;
			border-bottom: 1px solid #6e6e6e;
		}
	}

	.about-left-ul {
		li {
			height: 66px;
			transition: all 0.5s;
			overflow: hidden;
			border-bottom: 1px solid #6e6e6e;
		}
	}

	.about-left-li {
		padding: 22px 0;
		// padding-top: 34px;
		// padding-bottom: 20px;
		font-size: 25px;
		cursor: pointer;
		font-family: nexalight;
		display: flex;
		align-items: flex-end;
		div:nth-child(1) {
			font-family: nexabold;
			margin-bottom: -2px;
			min-width: 45px;
		}
		div:nth-child(2) {
			font-size: 24px;
			margin-right: 16px;
			margin-left: 6px;
			font-family: SourceHanSansNormal;
		}
		div:nth-child(3) {
			font-size: 22px;
			margin-bottom: -2px;
		}
	}
	.about-left,
	.about-right {
		height: 100vh;
		overflow: auto;
	}
	.about-right::-webkit-scrollbar {
		width: 0px;
	}
	.about-left::-webkit-scrollbar {
		width: 0px;
	}
	.about-right {
		width: 50%;
		padding: 40px 30px 0 30px;
		border-left: 1px solid #000;
	}

	.about-right-video {
		max-height: 390px;
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 22px;
		overflow: hidden;
		img:first-child {
			position: absolute;
			top: 0;
			left: 0;
			// height: 100%;
			z-index: 1;
		}
		img:last-child {
			position: relative;
			z-index: 2;
		}
		video {
			width: 100%;
		}
	}

	.about-right-text {
		padding-bottom: 22px;
		border-bottom: 1px solid #6e6e6e;
		h1 {
			margin-bottom: 10px;
		}
		p {
			// line-height: 42px;
			// text-align: justify;
			font-size: 24px;
			color: #231815;
			margin-bottom: 10px;
		}
		p:last-child {
			margin-bottom: 0;
		}
	}

	.about-right-clients {
		margin-top: 22px;
		padding-bottom: 22px;
		border-bottom: 1px solid #6e6e6e;
		div {
			width: 100%;
			// height: 311px;
			overflow: hidden;
			img {
				width: 100%;
			}
		}
		h1 {
			margin-bottom: 22px;
		}
	}

	.about-right-awards {
		margin-top: 22px;
		padding-bottom: 22px;
		h1 {
			margin-bottom: 22px;
		}
	}

	.awards-li {
		display: flex;
		justify-content: space-between;
		font-size: 20px;
		margin-bottom: 25px;
	}

	.about-left-content {
		padding-bottom: 34px;
		p {
			color: #231815;
		}
	}

	.about-content-p2 {
		font-size: 24px;
		margin-bottom: 12px;
	}

	.about-content-p3 {
		font-size: 20px;
		line-height: 26px;
		margin-bottom: 4px;
		font-family: nexalight;
	}

	.about-cont-nav-l {
		float: left;
		p {
			margin-bottom: 8px;
			font-size: 25px;
			font-family: nexalight;
		}
	}

	.about-left-cont-nav {
		margin-top: 12px;
		position: relative;
		p {
			font-family: SourceHanSansMedium;
			font-size: 24px;
			color: #231815;
		}
	}

	.about-cont-nav-r {
		width: 250px;
		height: 250px;
		// float: right;
		position: absolute;
		right: 0;
		top: -2px;
		img {
			width: 100%;
			height: 100%;
		}
	}

	.c-about-content-p3 {
		font-size: 16px;
		line-height: 28px;
	}

	.services-en {
		p {
			font-family: nexalight;
			font-size: 22px;
			margin-bottom: 3px;
		}
	}

	.hover-h1 {
		font-family: nexabold;
		span:nth-child(2) {
			font-size: 28px;
			margin: 0 16px;
			font-family: SourceHanSansBold;
		}
		div:nth-child(2) {
			font-family: SourceHanSansMedium;
		}
	}

	.c-padding-lr {
		padding-right: 10px;
		padding-left: 10px;
	}

	@media screen and (max-width: 1300px) {
		.box {
			// flex-direction: column;
			display: block;
			overflow: auto;
		}
		.about-left {
			width: 100%;
			height: max-content;
		}
		.about-right {
			width: 100%;
			height: max-content;
		}
		.about-right-video {
			max-height: none;
		}
	}
</style>
